<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.menu_popup && items">
  <div class="banner center" style="max-width:500px;">
    <div class="row row_header freeze_col freeze_height">
      <div class="col-9">
        {{localService.languageContent.menu_popup.menu_name}}
      </div>
      <div class="col-3">
        {{localService.languageContent.menu_popup.shortcut}}
      </div>
    </div>
    <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}" style="line-height:40px;">
      <div *ngFor="let item of items">
        <div class="row" *ngIf="item.menu.v7 == '0'">
          <div class="col-12">
            <div class="vertical_menu_parent" title="{{item.menu.v5}}">
              <i class="material-icons menu_icon">{{item.menu.v3}}</i>
              <span>{{item.menu.v5}}</span>
            </div>
          </div>
        </div>
        <div>
          <div *ngFor="let itemSub of item.subMenus">
            <div class="row" *ngIf="itemSub.menu.v6 != '13' && itemSub.menu.v7 == '0'">
              <div class="col-9">
                <div class="vertical_menu_child" title="{{itemSub.menu.v5}}">
                  <i class="material-icons menu_icon">{{itemSub.menu.v3}}</i>
                  <span>{{itemSub.menu.v5}}</span>
                </div>
              </div>
              <div class="col-3">
                <i class="material-icons button icon_adjust" *ngIf="itemSub.menu.v6 != '58' && itemSub.menu.v6 != '71'"
                  title="{{itemSub.menu.isSelected ? localService.languageContent.common.make_inactive : localService.languageContent.common.make_active}}"
                  (click)="onAction(3,item.menu.key, itemSub.menu.key)"
                  [ngStyle]="{'color': itemSub.menu.isSelected ? 'yellowgreen' : 'orangered' }">{{itemSub.menu.isSelected
                  ? "toggle_on" : "toggle_off"}}</i>
                <i class="material-icons menu_icon icon_adjust dummy_action" style="color: yellowgreen;"
                  *ngIf="itemSub.menu.v6 == '71'">circle</i>
                <i class="material-icons menu_icon icon_adjust dummy_action" style="color: orangered;"
                  *ngIf="itemSub.menu.v6 == '58'">circle</i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row freeze_col freeze_height" style="padding-top:10px;">
      <div class="col-12" style="text-align:right;">
        <button type="button" class="btn btn-secondary"
          (click)="onAction(1)">{{localService.languageContent.common.save}}</button>
      </div>
    </div>
  </div>
</div>
<span style="display:none;">
  <input type="button" class="on_language_changed" (click)="onLoad()" />
</span>